import React from 'react';
import s from './Store.module.css';
import Ribbon from '../../Ribbon/Ribbon';
import links from '../../../JSON/storeLinks.json';

function Store() {
  return (
    <section className={s.section} id="store">
      <h2 className={s.header}>де купити</h2>
      <ul className={s.list}>
        {links.map(el => {
          return (
            <li key={el.name}>
              <a href={el.link} target="blank">
                <svg className={s.svg}>
                  <use href={el.svg}></use>
                </svg>
              </a>
            </li>
          );
        })}
      </ul>
      <div className={s.div}>
        <Ribbon />
      </div>
    </section>
  );
}

export default Store;
